import { PortalAuthController } from '@mamba-le/auth';
import lodash from 'lodash';
class PortalAuth extends PortalAuthController {
  static Auth: PortalAuth;
  /**
   * 工厂函数
   * @static
   * @return {*}
   * @memberof PortalAuth
   */
  static onCreateFactoryAuth() {
    if (!lodash.isEmpty(PortalAuth.Auth)) {
      return PortalAuth.Auth;
    }
    return new PortalAuth();
  }
  constructor() {
    super({ PortalType: 'BP' });
    // if (!lodash.isEmpty(PortalAuth.Auth)) {
    //   return PortalAuth.Auth;
    // }
    // 客户端开启单例
    if (typeof window !== 'undefined') {
      PortalAuth.Auth = this;
    }
  }
}
export const onCreateFactoryAuth = PortalAuth.onCreateFactoryAuth;
